const scheduleTypes = {
  scheduleGeneric: 'scheduleGeneric',
}

export const scheduleFunctionTypes = {
  modifySchedule: 'modifySchedule',
};

export const onScheduleJobTypes = {
  updateScores30Minutes: 'ts_updateScores_30_minutes',
  updateScoresMorning: 'ts_updateScores_morning',
  ts_updateScores_night: 'ts_updateScores_night',
  checkNotification_15_minutes: 'checkNotification_15_minutes',
  scheduledNotification_gcs_hourly: 'scheduledNotification_gcs_hourly',
  scheduledNotification_gcs_weekly: 'scheduledNotification_gcs_weekly',
  scheduledNotification_gcs_monthly: 'scheduledNotification_gcs_monthly',
};

const callFsFunction = async (fsCall, callData) => {
  const data = await fsCall(scheduleTypes.scheduleGeneric, callData)
  return data
}

export const fsfn_schedule = (fsCall) => ({
  getSchedulerStatus: (jobKey) => getSchedulerStatus(fsCall, jobKey),
  toggleScheduler: (jobKey, enabled) => toggleScheduler(fsCall, jobKey, enabled),

})

const getSchedulerStatus = async (fsCall, jobKey) => {
  try {
    const callData = {
      scheduleFunctionType: scheduleFunctionTypes.modifySchedule,
      action: 'status',
      jobKey,
    }
    const response_data = await callFsFunction(fsCall, callData) // OK
    return response_data
  } catch (error) {
    console.error(error)
  }
}

const toggleScheduler = async (fsCall, jobKey, enabled) => {
  try {
    const callData = {
      scheduleFunctionType: scheduleFunctionTypes.modifySchedule,
      action: 'toggle',
      jobKey,
      enabled,
    }
    const response_data = await callFsFunction(fsCall, callData) // OK
    return response_data
  } catch (error) {
    console.error(error)
  }
}